import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
// import threatsScores from './threatsScores';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';

// Validation
import lowRiskAppetiteMessagesTpl from './messages/low-risk-appetite-threshold.messages.html';
import mediumRiskAppetiteMessagesTpl from './messages/medium-risk-appetite-threshold.messages.html';
import highRiskAppetiteMessagesTpl from './messages/high-risk-appetite-threshold.messages.html';
import riskWeightMessagesTpl from './messages/risk.weight.messages.html';
import customerTeamMessagesTpl from './messages/customer.team.messages.html';
import customerTeamDisplayDataMessagesTpl from './messages/customer.team.display.data.messages.html';


class dialogService {
  getOptions($event, {
    settings,
  }) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals: {
        settings,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.praSettingsDialog', [
  alerts,
  praDataService,
  constants,
  loaderService,
  ssDialogService,
  // threatsScores,
])
  .service('praSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('low-risk-appetite-threshold.messages.html', lowRiskAppetiteMessagesTpl);
    $templateCache.put('medium-risk-appetite-threshold.messages.html', mediumRiskAppetiteMessagesTpl);
    $templateCache.put('high-risk-appetite-threshold.messages.html', highRiskAppetiteMessagesTpl);
    $templateCache.put('risk.weight.messages.html', riskWeightMessagesTpl);
    $templateCache.put('customer.team.messages.html', customerTeamMessagesTpl);
    $templateCache.put('customer.team.display.data.messages.html', customerTeamDisplayDataMessagesTpl);
  })
  .name;
